import request from "../../request.js"
import request2 from "../../request2.js"
import qs from "qs";

// 上传文件接口
export  function uploadFileLocal(data) {
	return request({
		url: "/upload/uploadFileLocal",
		method: "POST",
		data
	})
}
// 识别身份证
export  function getIdCardInfo(data) {
	return request({
		url: "/upload/getIdCardInfo",
		method: "POST",
		data
	})
}
// 获取操作日志
export  function getSysLogList(data) {
	return request({
		url: "/sys-log/getSysLogList",
		method: "POST",
		data
	})
}
// 新增用户
export  function addSysUser(data) {
	return request({
		url: "/sys-user/addSysUser",
		method: "POST",
		data
	})
}
// 获取用户列表
export  function getSysUserList(data) {
	return request({
		url: "/sys-user/getSysUserList",
		method: "POST",
		data
	})
}
// 编辑用户
export  function updateSysUser(data) {
	return request({
		url: "/sys-user/updateSysUser",
		method: "POST",
		data
	})
}
// 登录
export  function doLogin(data) {
	return request({
		url: "/sys-user/doLogin",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除用户
export  function deleteSysUser(data) {
	return request({
		url: "/sys-user/deleteSysUser",
		method: "POST",
		data:qs.stringify(data)
	})
}

// 资产分类列表
export  function getAjAssetsClassList(data) {
	return request({
		url: "/aj-assets-class/getAjAssetsClassList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增资产分类
export  function addAjAssetsClass(data) {
	return request({
		url: "/aj-assets-class/addAjAssetsClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑资产分类
export  function updateAjAssetsClass(data) {
	return request({
		url: "/aj-assets-class/updateAjAssetsClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除资产分类
export  function deleteAjAssetsClass(data) {
	return request({
		url: "/aj-assets-class/deleteAjAssetsClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增厂商
export  function addAjManufacturer(data) {
	return request({
		url: "/aj-manufacturer/addAjManufacturer",
		method: "POST",
		data:qs.stringify(data)
	})
}

// 获取厂商列表
export  function getAjManufacturerList(data) {
	return request({
		url: "/aj-manufacturer/getAjManufacturerList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑厂商
export  function updateAjManufacturer(data) {
	return request({
		url: "/aj-manufacturer/updateAjManufacturer",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除厂商
export  function deleteAjManufacturer(data) {
	return request({
		url: "/aj-manufacturer/deleteAjManufacturer",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增公司资产
export  function addAjAssets(data) {
	return request({
		url: "/aj-assets/addAjAssets",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 公司资产列表
export  function getAjAssetsList(data) {
	return request({
		url: "/aj-assets/getAjAssetsList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑公司资产
export  function updateAjAssets(data) {
	return request({
		url: "/aj-assets/updateAjAssets",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除公司资质
export  function deleteAjAssets(data) {
	return request({
		url: "/aj-assets/deleteAjAssets",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 资产详情
export  function getAjAssetsDetails(data) {
	return request({
		url: "/aj-assets/getAjAssetsDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增配件分类
export  function addAjFittingsClass(data) {
	return request({
		url: "/aj-fittings-class/addAjFittingsClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除配件分类
export  function deleteAjFittingsClass(data) {
	return request({
		url: "/aj-fittings-class/deleteAjFittingsClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 配件分类列表
export  function getAjFittingsClassList(data) {
	return request({
		url: "/aj-fittings-class/getAjFittingsClassList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑配件分类
export  function updateAjFittingsClass(data) {
	return request({
		url: "/aj-fittings-class/updateAjFittingsClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增易耗品
export  function addAjConsumables(data) {
	return request({
		url: "/aj-consumables/addAjConsumables",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取易耗品列表
export  function getAjConsumablesList(data) {
	return request({
		url: "/aj-consumables/getAjConsumablesList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑易耗品
export  function updateAjConsumables(data) {
	return request({
		url: "/aj-consumables/updateAjConsumables",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除易耗品
export  function deleteAjConsumables(data) {
	return request({
		url: "/aj-consumables/deleteAjConsumables",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取电信运营商
export  function getAjOperatorTelecommunicationList(data) {
	return request({
		url: "/aj-operator-telecommunication/getAjOperatorTelecommunicationList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增手机卡
export  function addAjMobileCard(data) {
	return request({
		url: "/aj-mobile-card/addAjMobileCard",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取手机卡
export  function getAjMobileCardList(data) {
	return request({
		url: "/aj-mobile-card/getAjMobileCardList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑售价卡
export  function updateAjMobileCard(data) {
	return request({
		url: "/aj-mobile-card/updateAjMobileCard",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除手机卡
export  function deleteAjMobileCard(data) {
	return request({
		url: "/aj-mobile-card/deleteAjMobileCard",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增配件
export  function addAjFittings(data) {
	return request({
		url: "/aj-fittings/addAjFittings",
		method: "POST",
		data:qs.stringify(data)
	})
}
//配件列表
export  function getAjFittingsList(data) {
	return request({
		url: "/aj-fittings/getAjFittingsList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑配件
export  function updateAjFittings(data) {
	return request({
		url: "/aj-fittings/updateAjFittings",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除配件
export  function deleteAjFittings(data) {
	return request({
		url: "/aj-fittings/deleteAjFittings",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 配件详情
export  function getAjFittingsDetails(data) {
	return request({
		url: "/aj-fittings/getAjFittingsDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑配件关联资产
export  function updateAjFittingsAssets(data) {
	return request({
		url: "/aj-fittings/updateAjFittingsAssets",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 解除配件关联资产
export  function updateAjFittingsAssetsUnbinding(data) {
	return request({
		url: "/aj-fittings/updateAjFittingsAssetsUnbinding",
		method: "POST",
		data:qs.stringify(data)
	})
}

// 获取民族
export  function getSysNationList(data) {
	return request({
		url: "/sys-nation/getSysNationList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增花名册
export  function addAjUser(data) {
	return request({
		url: "/aj-user/addAjUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取花名册
export  function getAjUserList(data) {
	return request({
		url: "/aj-user/getAjUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取花名册2
export  function getAjUserListAll (data) {
	return request({
		url: "/aj-user/getAjUserListAll ",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取花名册
export  function getAjUserListOnJob(data) {
	return request({
		url: "/aj-user/getAjUserListOnJob",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取花名册
export  function getAjUserListLeave(data) {
	return request({
		url: "/aj-user/getAjUserListLeave",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取花名册
export  function getAjUserProveList(data) {
	return request({
		url: "/aj-user-prove/getAjUserProveList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取花名册
export  function getAjUserContractList(data) {
	return request({
		url: "/aj-user-contract/getAjUserContractList",
		method: "POST",
		data:qs.stringify(data)
	})
}

// 编辑花名册
export  function updateAjUser(data) {
	return request({
		url: "/aj-user/updateAjUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除花名册
export  function deleteAjUser(data) {
	return request({
		url: "/aj-user/deleteAjUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 重新入职
export  function updateAjUserEntryAgain(data) {
	return request({
		url: "/aj-user/updateAjUserEntryAgain",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 详情花名册
export  function getAjUserDetails(data) {
	return request({
		url: "/aj-user/getAjUserDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 通讯录
export  function getAddressBookList(data) {
	return request({
		url: "/address-book/getAddressBookList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑通讯录
export  function updateAddressBook(data) {
	return request({
		url: "/address-book/updateAddressBook",
		method: "POST",
		data:qs.stringify(data)
	})
}
// // 审核花名册
export  function updateAjUserCheck(data) {
	return request({
		url: "/aj-user/updateAjUserCheck",
		method: "POST",
		data:qs.stringify(data)
	})
}


// /新增折旧规则
export  function addAjRuleDepreciation(data) {
	return request({
		url: "/aj-rule-depreciation/addAjRuleDepreciation",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取折旧规则
export  function getAjRuleDepreciationList(data) {
	return request({
		url: "/aj-rule-depreciation/getAjRuleDepreciationList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑折旧规则 
export  function updateAjRuleDepreciation(data) {
	return request({
		url: "/aj-rule-depreciation/updateAjRuleDepreciation",
		method: "POST",
		data:qs.stringify(data)
	})
}
//折旧规则详情 
export  function getAjRuleDepreciationDetails(data) {
	return request({
		url: "/aj-rule-depreciation/getAjRuleDepreciationDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除折旧规则
export  function deleteAjRuleDepreciation(data) {
	return request({
		url: "/aj-rule-depreciation/deleteAjRuleDepreciation",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 故障列表
export  function getAjAssetsHitchList(data) {
	return request({
		url: "/aj-assets-hitch/getAjAssetsHitchList",
		method: "POST",
		data:qs.stringify(data)
	})
}

// 处理故障
export  function updateAjAssetsHitch(data) {
	return request({
		url: "/aj-assets-hitch/updateAjAssetsHitch",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除故障 
export  function deleteAjAssetsHitch(data) {
	return request({
		url: "/aj-assets-hitch/deleteAjAssetsHitch",
		method: "POST",
		data:qs.stringify(data)
	})
}

//借还记录 
export  function getAjUserBorrowReturnList(data) {
	return request({
		url: "/aj-user-borrow-return/getAjUserBorrowReturnList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 归还
export  function addAjUserReturn(data){
	return request({
		url: "/aj-user-borrow-return/addAjUserReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 借出
export  function addAjUserBorrow(data) {
	return request({
		url: "/aj-user-borrow-return/addAjUserBorrow",
		method: "POST",
		data:qs.stringify(data)
	})
}
//提出故障 
export  function addAjAssetsHitch(data) {
	return request({
		url: "/aj-assets-hitch/addAjAssetsHitch",
		method: "POST",
		data:qs.stringify(data)
	})
}

//详情厂商 
export  function getAjManufacturerDetails(data) {
	return request({
		url: "/aj-manufacturer/getAjManufacturerDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//易耗品入库 
export  function updateAjConsumablesStock(data) {
	return request({
		url: "/aj-consumables-record/updateAjConsumablesStock",
		method: "POST",
		data:qs.stringify(data)
	})
}
//出入库记录 
export  function getAjConsumablesRecordList(data) {
	return request({
		url: "/aj-consumables-record/getAjConsumablesRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手机卡详情 
export  function getAjMobileCardDetails(data) {
	return request({
		url: "/aj-mobile-card/getAjMobileCardDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//通知 
export  function getSysNoticeList(data) {
	return request({
		url: "/sys-notice/getSysNoticeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//通知 
export  function getSysNoticeListTitle(data) {
	return request({
		url: "/sys-notice/getSysNoticeListTitle",
		method: "POST",
		data:qs.stringify(data)
	})
}
//没读通知数量 
export  function getSysNoticeUnReadNum(data) {
	return request({
		url: "/sys-notice/getSysNoticeUnReadNum",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除通知 
export  function deleteSysNoticeRead(data) {
	return request({
		url: "/sys-notice/deleteSysNoticeRead",
		method: "POST",
		data:qs.stringify(data)
	})
}

//通知已读 
export  function updateSysNoticeRead(data) {
	return request({
		url: "/sys-notice/updateSysNoticeRead",
		method: "POST",
		data:qs.stringify(data)
	})
}
//一键已读
export  function updateSysNoticeReadAll(data) {
	return request({
		url: "/sys-notice/updateSysNoticeReadAll",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册导出word
export  function exportAjUserWord(data) {
	return request({
		url: "/aj-user/exportAjUserWord",
		method: "POST",
		data:qs.stringify(data)
	})
}

//资产导入 
export  function uploadAjAssets(data) {
	return request({
		url: "/aj-assets/uploadAjAssets",
		method: "POST",
		data
	})
}
//执行-资产 
export  function uploadImportAjAssets(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjAssets",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 导出-资产
export  function exportAjAssets(data) {
	return request({
		url: "/aj-assets/exportAjAssets",
		method: "POST",
		data:qs.stringify(data)
	})
}
//执行 -配件 
export  function uploadImportAjFittings(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjFittings",
		method: "POST",
		data:qs.stringify(data)
	})
}

//导出配件 
export  function exportAjFittings(data) {
	return request({
		url: "/aj-fittings/exportAjFittings",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导入 -配件 
export  function uploadAjFittings(data) {
	return request({
		url: "/aj-fittings/uploadAjFittings",
		method: "POST",
		data
	})
}
// 导入-易耗品
export  function uploadAjAjConsumables(data) {
	return request({
		url: "/aj-consumables/uploadAjAjConsumables",
		method: "POST",
		data
	})
}
//导出-易耗品 
export  function exportAjConsumables(data) {
	return request({
		url: "/aj-consumables/exportAjConsumables",
		method: "POST",
		data:qs.stringify(data)
	})
}
//执行-易耗品 
export  function uploadImportAjConsumables(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjConsumables",
		method: "POST",
		data:qs.stringify(data)
	})
}
//执行手机卡 
export  function uploadImportAjMobileCard(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjMobileCard",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出手机卡 
export  function exportAjMobileCard(data) {
	return request({
		url: "/aj-mobile-card/exportAjMobileCard",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导入手机卡 
export  function uploadAjMobileCard(data) {
	return request({
		url: "/aj-mobile-card/uploadAjMobileCard",
		method: "POST",
		data
	})
}
//执行花名册 
export  function uploadImportAjUser(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//执行花名册 
export  function uploadImportAjUserLeave(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjUserLeave",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出花名册 
export  function exportAjUser(data) {
	return request({
		url: "/aj-user/exportAjUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导入花名册 
export  function uploadAjUser(data) {
	return request({
		url: "/aj-user/uploadAjUser",
		method: "POST",
		data
	})
}
//导入花名册-离职员工 
export  function uploadAjUserLeave(data) {
	return request({
		url: "/aj-user/uploadAjUserLeave",
		method: "POST",
		data
	})
}
//易耗品损耗 
export  function addAjUserLoss(data) {
	return request({
		url: "/aj-user-borrow-return/addAjUserLoss",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑身份证 
export  function updateAjUserIdCard(data) {
	return request({
		url: "/aj-user/updateAjUserIdCard",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑花名册证书 
export  function updateAjUserCertificate(data) {
	return request({
		url: "/aj-user/updateAjUserCertificate",
		method: "POST",
		data:qs.stringify(data)
	})
}
//统计-数量 
export  function getStatisticsNums(data) {
	return request({
		url: "/home/getStatisticsNums",
		method: "POST",
		data:qs.stringify(data)
	})
}
//统计-维修
export  function getStatisticsRepair(data) {
	return request({
		url: "/home/getStatisticsRepair",
		method: "POST",
		data:qs.stringify(data)
	})
}
//统计-质保 
export  function getStatisticsWarranty(data) {
	return request({
		url: "/home/getStatisticsWarranty",
		method: "POST",
		data:qs.stringify(data)
	})
}
//通讯录导出 
export  function exportAddressBook(data) {
	return request({
		url: "/address-book/exportAddressBook",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产-归还 
export  function updateAjAssetsReturn(data) {
	return request({
		url: "/aj-assets/updateAjAssetsReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产-退租 
export  function updateAjAssetsReturnStore(data) {
	return request({
		url: "/aj-assets/updateAjAssetsReturnStore",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 配件-退租
export  function updateAjFittingsReturnStore(data) {
	return request({
		url: "/aj-fittings/updateAjFittingsReturnStore",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 手机卡-退租
export  function updateAjMobileCardReturn(data) {
	return request({
		url: "/aj-mobile-card/updateAjMobileCardReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产租用 
export  function getStatisticsHire(data) {
	return request({
		url: "/home/getStatisticsHire",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 借还记录导出
export  function exportBorrowReturn(data) {
	return request({
		url: "/aj-user-borrow-return/exportBorrowReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//中国地区信息 
export  function getSysRegionList(data) {
	return request({
		url: "/sys-region/getSysRegionList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取导出word模板 
export  function getAjUserWordList(data) {
	return request({
		url: "/aj-user-word/getAjUserWordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑模板 
export  function updateAjUserWord(data) {
	return request({
		url: "/aj-user-word/updateAjUserWord",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册-离职
export  function updateAjUserLeave(data) {
	return request({
		url: "/aj-user/updateAjUserLeave",
		method: "POST",
		data:qs.stringify(data)
	})
}
//花名册-银行卡信息编辑 
export  function updateAjUserBank(data) {
	return request({
		url: "/aj-user/updateAjUserBank",
		method: "POST",
		data:qs.stringify(data)
	})
}
//花名册-联系人基本信息 
export  function updateAjUserContact(data) {
	return request({
		url: "/aj-user/updateAjUserContact",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册-新增其他证书
export  function addAjUserProve(data) {
	return request({
		url: "/aj-user-prove/addAjUserProve",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册 - 编辑其他证书
export  function updateAjUserProve(data) {
	return request({
		url: "/aj-user-prove/updateAjUserProve",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册 - 证书列表
export  function getAjUserOtherProveList(data) {
	return request({
		url: "/aj-user-prove/getAjUserOtherProveList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册 - 删除证书
export  function deleteAjUserProve(data) {
	return request({
		url: "/aj-user-prove/deleteAjUserProve",
		method: "POST",
		data:qs.stringify(data)
	})
}
//花名册-删除劳动合同 
export  function deleteAjUserContract(data) {
	return request({
		url: "/aj-user-contract/deleteAjUserContract",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册-新增劳动合同
export  function addAjUserContract(data) {
	return request({
		url: "/aj-user-contract/addAjUserContract",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册-列表劳动合同
export  function getAjUserOtherContractList(data) {
	return request({
		url: "/aj-user-contract/getAjUserOtherContractList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册-编辑劳动合同 
export  function updateAjUserContract(data) {
	return request({
		url: "/aj-user-contract/updateAjUserContract",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册 - 换区花名册筛选选项 
export  function getAjUserItem(data) {
	return request({
		url: "/aj-user/getAjUserItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑借还记录
export  function updateBorrowReturn(data) {
	return request({
		url: "/aj-user-borrow-return/updateBorrowReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 导出使用记录
export  function exportAddressBookRecord(data) {
	return request({
		url: "/address-book/exportAddressBookRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑资产
export  function updateAjAssetsStatus(data) {
	return request({
		url: "/aj-assets/updateAjAssetsStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增转岗记录
export  function addAjUserPostRecord(data) {
	return request({
		url: "/aj-user-post-record/addAjUserPostRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 转岗记录列表
export  function getAjUserPostRecordList(data) {
	return request({
		url: "/aj-user-post-record/getAjUserPostRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑壮岗记录
export  function updateAjUserPostRecord(data) {
	return request({
		url: "/aj-user-post-record/updateAjUserPostRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 同步更新
export  function getAssetsAjUserSyn(data) {
	return request({
		url: "/aj-user/getAssetsAjUserSyn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增部门 
export  function addAjUserDepartment(data) {
	return request({
		url: "/aj-user-department/addAjUserDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除部门 
export  function deleteAjUserDepartment(data) {
	return request({
		url: "/aj-user-department/deleteAjUserDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//部门列表 
export  function getAjUserDepartmentList(data) {
	return request({
		url: "/aj-user-department/getAjUserDepartmentList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑部门 
export  function updateAjUserDepartment(data) {
	return request({
		url: "/aj-user-department/updateAjUserDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取列表平筛选项 
export  function getAjAssetsItems(data) {
	return request({
		url: "/home/getAjAssetsItems",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑部门 
export  function updateAjUserDepartments(data) {
	return request({
		url: "/aj-user/updateAjUserDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//配件-一键归还 
export  function updateAjFittingsReturn(data) {
	return request({
		url: "/aj-fittings/updateAjFittingsReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}


//证书列表
export  function getSysCjCerList(data) {
	return request({
		url: "/sys-cj-cer/getSysCjCerList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增证书
export  function addSysCjCer(data) {
	return request({
		url: "/sys-cj-cer/addSysCjCer",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑证书
export  function updateSysCjCer(data) {
	return request({
		url: "/sys-cj-cer/updateSysCjCer",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除证书
export  function deleteSysCjCer(data) {
	return request({
		url: "/sys-cj-cer/deleteSysCjCer",
		method: "POST",
		data:qs.stringify(data)
	})
}

//项目列表
export  function getSysCjProjectList(data) {
	return request({
		url: "/sys-cj-project/getSysCjProjectList",
		method: "POST",
		data:qs.stringify(data)
	})
}
export  function getSysCjProjectDetails(data) {
	return request({
		url: "/sys-cj-project/getSysCjProjectDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增项目
export  function addSysCjProject(data) {
	return request({
		url: "/sys-cj-project/addSysCjProject",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑项目
export  function updateSysCjProject(data) {
	return request({
		url: "/sys-cj-project/updateSysCjProject",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑项目状态
export  function updateSysCjProjectStatus(data) {
	return request({
		url: "/sys-cj-project/updateSysCjProjectStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除项目
export  function deleteSysCjProject(data) {
	return request({
		url: "/sys-cj-project/deleteSysCjProject",
		method: "POST",
		data:qs.stringify(data)
	})
}

//数据库
export  function getSysCjProjectSqlBaseList(data) {
	return request({
		url: "/sys-cj-project-sql-base/getSysCjProjectSqlBaseList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//数据库记录列表
export  function getSysCjProjectSqlList(data) {
	return request({
		url: "/sys-cj-project-sql/getSysCjProjectSqlList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增数据库记录
export  function addSysCjProjectSql(data) {
	return request({
		url: "/sys-cj-project-sql/addSysCjProjectSql",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑数据库记录
export  function updateSysCjProjectSql(data) {
	return request({
		url: "/sys-cj-project-sql/updateSysCjProjectSql",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除数据库记录
export  function deleteSysCjProjectSql(data) {
	return request({
		url: "/sys-cj-project-sql/deleteSysCjProjectSql",
		method: "POST",
		data:qs.stringify(data)
	})
}
//里程碑列表
export  function getSysCjProjectMilestoneList(data) {
	return request({
		url: "/sys-cj-project-milestone/getSysCjProjectMilestoneList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增里程碑
export  function addSysCjProjectMilestone(data) {
	return request({
		url: "/sys-cj-project-milestone/addSysCjProjectMilestone",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑里程碑
export  function updateSysCjProjectMilestone(data) {
	return request({
		url: "/sys-cj-project-milestone/updateSysCjProjectMilestone",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑里程碑
export  function deleteSysCjProjectMilestone(data) {
	return request({
		url: "/sys-cj-project-milestone/deleteSysCjProjectMilestone",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增花名册归属
export  function addAjUserBelong(data) {
	return request({
		url: "/aj-user-belong/addAjUserBelong",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除花名册归属
export  function deleteAjUserBelong(data) {
	return request({
		url: "/aj-user-belong/deleteAjUserBelong",
		method: "POST",
		data:qs.stringify(data)
	})
}
//归属地列表
export  function getAjUserBelongList(data) {
	return request({
		url: "/aj-user-belong/getAjUserBelongList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑花名册归属
export  function updateAjUserBelong(data) {
	return request({
		url: "/aj-user-belong/updateAjUserBelong",
		method: "POST",
		data:qs.stringify(data)
	})
}
//首页统计-待入职用户
export  function getStatisticsEntrySoon(data) {
	return request({
		url: "/home/getStatisticsEntrySoon",
		method: "POST",
		data:qs.stringify(data)
	})
}
//修改密码
export  function updateSysUserPw(data) {
	return request({
		url: "/sys-user/updateSysUserPw",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增社保公积金基数
export  function addAjSocialBase(data) {
	return request({
		url: "/aj-social-base/addAjSocialBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除社保公积金基数
export  function deleteAjSocialBase(data) {
	return request({
		url: "/aj-social-base/deleteAjSocialBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询社保公积金基数
export  function getAjSocialBaseList(data) {
	return request({
		url: "/aj-social-base/getAjSocialBaseList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑社保公积金基数
export  function updateAjSocialBase(data) {
	return request({
		url: "/aj-social-base/updateAjSocialBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增公积金账单
export  function addAjSocialBaseUserFund(data) {
	return request({
		url: "/aj-social-base-user-fund/addAjSocialBaseUserFund",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除公积金账单
export  function deleteAjSocialBaseUserFund(data) {
	return request({
		url: "/aj-social-base-user-fund/deleteAjSocialBaseUserFund",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询公积金账单
export  function getAjSocialBaseUserListFund(data) {
	return request({
		url: "/aj-social-base-user-fund/getAjSocialBaseUserListFund",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑公积金账单
export  function updateAjSocialBaseUserFund(data) {
	return request({
		url: "/aj-social-base-user-fund/updateAjSocialBaseUserFund",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增社保账单
export  function addAjSocialBaseUserSecurity(data) {
	return request({
		url: "/aj-social-base-user-security/addAjSocialBaseUserSecurity",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除社保账单
export  function deleteAjSocialBaseUserSecurity(data) {
	return request({
		url: "/aj-social-base-user-security/deleteAjSocialBaseUserSecurity",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询社保账单
export  function getAjSocialBaseUserListSecurity(data) {
	return request({
		url: "/aj-social-base-user-security/getAjSocialBaseUserListSecurity",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑社保账单
export  function updateAjSocialBaseUserSecurity(data) {
	return request({
		url: "/aj-social-base-user-security/updateAjSocialBaseUserSecurity",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询社保公积金台账
export  function getAjSocialBaseListSocialFund(data) {
	return request({
		url: "/aj-social-base-user/getAjSocialBaseListSocialFund",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询服务费税费
export  function getAjSocialBaseUserListServiceCharge(data) {
	return request({
		url: "/aj-social-base-user/getAjSocialBaseUserListServiceCharge",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量上传社保公积金基数
export  function uploadAjSocialBase(data) {
	return request({
		url: "/aj-social-base/uploadAjSocialBase",
		method: "POST",
		data
	})
}
//批量上传社保公积金基数-执行
export  function uploadImportAjSocialBase(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjSocialBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公积金账单-导入
export  function uploadAjSocialBaseFund(data) {
	return request({
		url: "/aj-social-base-user-fund/uploadAjSocialBaseFund",
		method: "POST",
		data
	})
}
//公积金账单-导入执行
export  function uploadImportAjSocialBaseFund(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjSocialBaseFund",
		method: "POST",
		data:qs.stringify(data)
	})
}
//社保账单-导入
export  function uploadAjSocialBaseSecurity(data) {
	return request({
		url: "/aj-social-base-user-security/uploadAjSocialBaseSecurity",
		method: "POST",
		data
	})
}
//社保账单-导入执行
export  function uploadImportAjSocialBaseSecurity(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjSocialBaseSecurity",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增参保主体
export  function addAjSocialServiceCharge(data) {
	return request({
		url: "/aj-social-service-charge/addAjSocialServiceCharge",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除参保主体
export  function deleteAjSocialServiceCharge(data) {
	return request({
		url: "/aj-social-service-charge/deleteAjSocialServiceCharge",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表参保主体
export  function getAjSocialServiceChargeList(data) {
	return request({
		url: "/aj-social-service-charge/getAjSocialServiceChargeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑参保主体
export  function updateAjSocialServiceCharge(data) {
	return request({
		url: "/aj-social-service-charge/updateAjSocialServiceCharge",
		method: "POST",
		data:qs.stringify(data)
	})
}

// 权限角色-新增
export  function addAyRole(data) {
	return request({
		url: "/ay-role/addAyRole",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 权限角色-删除
export  function deleteAyRole(data) {
	return request({
		url: "/ay-role/deleteAyRole",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 权限角色-编辑
export  function updateAyRole(data) {
	return request({
		url: "/ay-role/updateAyRole",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 权限角色-编辑角色权限
export  function updateAyRoleAuth(data) {
	return request({
		url: "/ay-role/updateAyRoleAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 权限角色-获取
export  function getAyRoleList(data) {
	return request({
		url: "/ay-role/getAyRoleList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取权限角色
export  function getAyRoleAuthList(data) {
	return request({
		url: "/ay-role/getAyRoleAuthList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 菜单权限 -新增
export  function addAyAuth(data) {
	return request({
		url: "/ay-auth/addAyAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 菜单权限 -删除
export  function deleteAyAuth(data) {
	return request({
		url: "/ay-auth/deleteAyAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 菜单权限 -列表
export  function getAyAuthList(data) {
	return request({
		url: "/ay-auth/getAyAuthList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 菜单权限 - 编辑
export  function updateAyAuth(data) {
	return request({
		url: "/ay-auth/updateAyAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 菜单权限 - 编辑菜单目录的父级
export  function updateAyAuthParent(data) {
	return request({
		url: "/ay-auth/updateAyAuthParent",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 菜单权限 - 获取菜单tree
export  function getAyAuthTree(data) {
	return request({
		url: "/ay-auth/getAyAuthTree",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产管理-资产花名册
export  function getAjUserListAssets(data) {
	return request({
		url: "/aj-user/getAjUserListAssets",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增便签
export  function addSysUserNote(data) {
	return request({
		url: "/sys-user-note/addSysUserNote",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除便签
export  function deleteSysUserNote(data) {
	return request({
		url: "/sys-user-note/deleteSysUserNote",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取便签
export  function getSysUserNote(data) {
	return request({
		url: "/sys-user-note/getSysUserNote",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑便签
export  function updateSysUserNote(data) {
	return request({
		url: "/sys-user-note/updateSysUserNote",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑便签-已处理
export  function updateSysUserNoteStatus(data) {
	return request({
		url: "/sys-user-note/updateSysUserNoteStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//处理报错接口-查询
export  function getSysMsgErrorGlobalList(data) {
	return request({
		url: "/sys-msg-error-global/getSysMsgErrorGlobalList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//处理报错接口-已处理
export  function updateSysMsgErrorGlobalStatus(data) {
	return request({
		url: "/sys-msg-error-global/updateSysMsgErrorGlobalStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//补充更新花名册
export  function uploadAjUserUpdate(data) {
	return request({
		url: "/aj-user/uploadAjUserUpdate",
		method: "POST",
		data
	})
}
//新增公积金基数
export  function addAjSocialBaseFund(data) {
	return request({
		url: "/aj-social-base/addAjSocialBaseFund",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑公积金基数
export  function updateAjSocialBaseFund(data) {
	return request({
		url: "/aj-social-base/updateAjSocialBaseFund",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量导入公积金基数
export  function uploadAjSocialBaseFunds(data) {
	return request({
		url: "/aj-social-base/uploadAjSocialBaseFund",
		method: "POST",
		data
	})
}
//获取用户信息
export  function getSysUserDetails(data) {
	return request({
		url: "/sys-user/getSysUserDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产申请列表
export  function getAjUserBorrowApplyList(data) {
	return request({
		url: "/aj-user-borrow-apply/getAjUserBorrowApplyList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产申请删除
export  function deleteAjUserBorrowApply(data) {
	return request({
		url: "/aj-user-borrow-apply/deleteAjUserBorrowApply",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产申请编辑
export  function updateAjUserBorrowApply(data) {
	return request({
		url: "/aj-user-borrow-apply/updateAjUserBorrowApply",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产申请审核
export  function updateAjUserBorrowApplyCheck(data) {
	return request({
		url: "/aj-user-borrow-apply/updateAjUserBorrowApplyCheck",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产花名册导出
export  function exportAjUserAssets(data) {
	return request({
		url: "/aj-user/exportAjUserAssets",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增支付渠道
export  function addAjPurchasePayChannel(data) {
	return request({
		url: "/aj-purchase-pay-channel/addAjPurchasePayChannel",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除支付渠道
export  function deleteAjPurchasePayChannel(data) {
	return request({
		url: "/aj-purchase-pay-channel/deleteAjPurchasePayChannel",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表支付渠道
export  function getAjPurchasePayChannelList(data) {
	return request({
		url: "/aj-purchase-pay-channel/getAjPurchasePayChannelList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑支付渠道
export  function updateAjPurchasePayChannel(data) {
	return request({
		url: "/aj-purchase-pay-channel/updateAjPurchasePayChannel",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增公共选项
export  function addAjPurchasePublicItem(data) {
	return request({
		url: "/aj-purchase-public-item/addAjPurchasePublicItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除公共选项
export  function deleteAjPurchasePublicItem(data) {
	return request({
		url: "/aj-purchase-public-item/deleteAjPurchasePublicItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表公共选项
export  function getAjPurchasePublicItemList(data) {
	return request({
		url: "/aj-purchase-public-item/getAjPurchasePublicItemList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑公共选项
export  function updateAjPurchasePublicItem(data) {
	return request({
		url: "/aj-purchase-public-item/updateAjPurchasePublicItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增收入礼品
export  function addAjPurchaseGift(data) {
	return request({
		url: "/aj-purchase-gift/addAjPurchaseGift",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除收入礼品
export  function deleteAjPurchaseGift(data) {
	return request({
		url: "/aj-purchase-gift/deleteAjPurchaseGift",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表收入礼品
export  function getAjPurchaseGiftList(data) {
	return request({
		url: "/aj-purchase-gift/getAjPurchaseGiftList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑收入礼品
export  function updateAjPurchaseGift(data) {
	return request({
		url: "/aj-purchase-gift/updateAjPurchaseGift",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增支出收入记录
export  function addAjPurchaseOutIn(data) {
	return request({
		url: "/aj-purchase-out-in/addAjPurchaseOutIn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除支出收入记录
export  function deleteAjPurchaseOutIn(data) {
	return request({
		url: "/aj-purchase-out-in/deleteAjPurchaseOutIn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表支出收入记录
export  function getAjPurchaseOutInList(data) {
	return request({
		url: "/aj-purchase-out-in/getAjPurchaseOutInList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑支出收入记录
export  function updateAjPurchaseOutIn(data) {
	return request({
		url: "/aj-purchase-out-in/updateAjPurchaseOutIn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//统计支出收入记录
export  function getAjPurchaseOutInStatistics(data) {
	return request({
		url: "/aj-purchase-out-in/getAjPurchaseOutInStatistics",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量导入支出记录
export  function uploadAjPurchaseOutIn(data) {
	return request({
		url: "/aj-purchase-out-in/uploadAjPurchaseOutIn",
		method: "POST",
		data
	})
}
//统计支出收入记录
export  function uploadImportAjPurchaseOutIn(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjPurchaseOutIn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公共选项列表去除部门的
export  function getAjPurchasePublicItemListNotDt(data) {
	return request({
		url: "/aj-purchase-public-item/getAjPurchasePublicItemListNotDt",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出统计
export  function exportAjPurchaseOutInStatistics(data) {
	return request({
		url: "/aj-purchase-out-in/exportAjPurchaseOutInStatistics",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产申请详情
export  function getAjUserBorrowApplyDetails(data) {
	return request({
		url: "/aj-user-borrow-apply/getAjUserBorrowApplyDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手机卡实名信息统计
export  function getAjMobileCardRealNameStatistics(data) {
	return request({
		url: "/aj-mobile-card/getAjMobileCardRealNameStatistics",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出手机卡实名信息统计
export  function exportAjMobileCardRealNameStatistics(data) {
	return request({
		url: "/aj-mobile-card/exportAjMobileCardRealNameStatistics",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询钉钉会议室
export  function getAjDingTalkRoomList(data) {
	return request({
		url: "/aj-ding-talk-room/getAjDingTalkRoomList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询钉钉会议室详情
export  function getAjDingTalkRoomDetails(data) {
	return request({
		url: "/aj-ding-talk-room/getAjDingTalkRoomDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增会议室
export  function addAjDingTalkRoomList(data) {
	return request({
		url: "/aj-ding-talk-room/addAjDingTalkRoomList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除会议室
export  function deleteAjDingTalkRoomList(data) {
	return request({
		url: "/aj-ding-talk-room/deleteAjDingTalkRoomList",
		method: "POST",
		data:qs.stringify(data)
	})
}

//编辑会议室
export  function updateAjDingTalkRoomList(data) {
	return request({
		url: "/aj-ding-talk-room/updateAjDingTalkRoomList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增会议室日程
export  function addAjDingTalkScheduleItemList(data) {
	return request({
		url: "/aj-ding-talk-schedule-item/addAjDingTalkScheduleItemList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除会议室日程
export  function deleteAjDingTalkScheduleItemList(data) {
	return request({
		url: "/aj-ding-talk-schedule-item/deleteAjDingTalkScheduleItemList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询会议室日程
export  function getAjDingTalkScheduleItemList(data) {
	return request({
		url: "/aj-ding-talk-schedule-item/getAjDingTalkScheduleItemList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑会议室日程
export  function updateAjDingTalkScheduleItemList(data) {
	return request({
		url: "/aj-ding-talk-schedule-item/updateAjDingTalkScheduleItemList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//普通会议室统计
export  function getAjDingTalkRoomTypeOneStatistics(data) {
	return request({
		url: "/aj-ding-talk-room/getAjDingTalkRoomTypeOneStatistics",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量更新手机卡绑定账号
export  function uploadAjMobileCardBindAccount(data) {
	return request({
		url: "/aj-mobile-card/uploadAjMobileCardBindAccount",
		method: "POST",
		data
	})
}
//批量更新手机卡绑定账号-执行
export  function uploadImportAjMobileCardBindAccount(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjMobileCardBindAccount",
		method: "POST",
		data:qs.stringify(data)
	})
}

//高德账单标记类型
export  function getAjDingTalkGaodeRecordSignTypeList(data) {
	return request({
		url: "/aj-ding-talk-gaode-record-sign/getAjDingTalkGaodeRecordSignTypeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//高德账单标记记录
export  function getAjDingTalkGaodeRecordSignList(data) {
	return request({
		url: "/aj-ding-talk-gaode-record-sign/getAjDingTalkGaodeRecordSignList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除高德账单标记记录
export  function deleteAjDingTalkGaodeRecordSign(data) {
	return request({
		url: "/aj-ding-talk-gaode-record-sign/deleteAjDingTalkGaodeRecordSign",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增工装信息
export  function addAjClothesWare(data) {
	return request2({
		url: "/aj-clothes-ware/addAjClothesWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除工装信息
export  function deleteAjClothesWare(data) {
	return request2({
		url: "/aj-clothes-ware/deleteAjClothesWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取工装信息详情
export  function getAjClothesWareDetails(data) {
	return request2({
		url: "/aj-clothes-ware/getAjClothesWareDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取工装信息
export  function getAjClothesWareList(data) {
	return request2({
		url: "/aj-clothes-ware/getAjClothesWareList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑工装信息
export  function updateAjClothesWare(data) {
	return request2({
		url: "/aj-clothes-ware/updateAjClothesWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增工装规格
export  function addAjClothesWareScale(data) {
	return request2({
		url: "/aj-clothes-ware-scale/addAjClothesWareScale",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除工装规格
export  function deleteAjClothesWareScale(data) {
	return request2({
		url: "/aj-clothes-ware-scale/deleteAjClothesWareScale",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取工装规格
export  function getAjClothesWareScaleList(data) {
	return request2({
		url: "/aj-clothes-ware-scale/getAjClothesWareScaleList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑工装规格
export  function updateAjClothesWareScale(data) {
	return request2({
		url: "/aj-clothes-ware-scale/updateAjClothesWareScale",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取用户工装申请
export  function getAjClothesApplyList(data) {
	return request2({
		url: "/aj-clothes-apply/getAjClothesApplyList",
		method: "POST",
		data:qs.stringify(data)
	})
}
export  function uploadAjClothesApply(data) {
	return request2({
		url: "/aj-clothes-apply/uploadAjClothesApply",
		method: "POST",
		data
	})
}
//删除用户工装申请
export  function deleteAjClothesApply(data) {
	return request2({
		url: "/aj-clothes-apply/deleteAjClothesApply",
		method: "POST",
		data:qs.stringify(data)
	})
}
//详情用户工装申请
export  function getAjClothesApplyDetails(data) {
	return request2({
		url: "/aj-clothes-apply/getAjClothesApplyDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装申请预生成订单
export  function getAjClothesOrderPreconditioning(data) {
	return request2({
		url: "/aj-clothes-order/getAjClothesOrderPreconditioning",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增工装申请预生成订单
export  function addAjClothesOrder(data) {
	return request2({
		url: "/aj-clothes-order/addAjClothesOrder",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装订单列表
export  function getAjClothesOrderList(data) {
	return request2({
		url: "/aj-clothes-order/getAjClothesOrderList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装订单列表详情
export  function getAjClothesOrderDetails(data) {
	return request2({
		url: "/aj-clothes-order/getAjClothesOrderDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装申请订单购买
export  function updateAjClothesOrderToBuy(data) {
	return request2({
		url: "/aj-clothes-order/updateAjClothesOrderToBuy",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装申请订单到货
export  function updateAjClothesOrderArrival(data) {
	return request2({
		url: "/aj-clothes-order/updateAjClothesOrderArrival",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装申请订单领取
export  function updateAjClothesApplyItemReceive(data) {
	return request2({
		url: "/aj-clothes-order/updateAjClothesApplyItemReceive",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装申请订单换货
export  function updateAjClothesApplyItemExchange(data) {
	return request2({
		url: "/aj-clothes-order/updateAjClothesApplyItemExchange",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装申请订单换货预处理
export  function getAjClothesOrderPreconditioningExchange(data) {
	return request2({
		url: "/aj-clothes-order/getAjClothesOrderPreconditioningExchange",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装申请订单换货确定新增
export  function addAjClothesOrderExchange(data) {
	return request2({
		url: "/aj-clothes-order/addAjClothesOrderExchange",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公章模板类型列表
export  function getAjSealModelList(data) {
	return request({
		url: "/aj-seal-model/getAjSealModelList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公章模板生成记录-新增
export  function addAjSealModelRecord(data) {
	return request({
		url: "/aj-seal-model-record/addAjSealModelRecord",
		method: "POST",
		data
	})
}
//公章模板生成记录-列表
export  function getAjSealModelRecordList(data) {
	return request({
		url: "/aj-seal-model-record/getAjSealModelRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公章模板生成记录-编辑参数
export  function updateAjSealModelRecordParams(data) {
	return request({
		url: "/aj-seal-model-record/updateAjSealModelRecordParams",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公章模板生成记录-删除
export  function deleteAjSealModelRecord(data) {
	return request({
		url: "/aj-seal-model-record/deleteAjSealModelRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑花名册工装信息
export  function updateAjUserClothes(data) {
	return request({
		url: "/aj-user/updateAjUserClothes",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑花名册工装信息
export  function updateAjUserPack(data) {
	return request({
		url: "/aj-user/updateAjUserPack",
		method: "POST",
		data:qs.stringify(data)
	})
}
//工装订单-内部兑换
export  function updateAjClothesApplyItemExchangeInside(data) {
	return request2({
		url: "/aj-clothes-order/updateAjClothesApplyItemExchangeInside",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增颜色
export  function addSysColorWare(data) {
	return request({
		url: "/sys-color-ware/addSysColorWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除颜色
export  function deleteSysColorWare(data) {
	return request({
		url: "/sys-color-ware/deleteSysColorWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取颜色
export  function getSysColorWareList(data) {
	return request({
		url: "/sys-color-ware/getSysColorWareList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑颜色
export  function updateSysColorWare(data) {
	return request({
		url: "/sys-color-ware/updateSysColorWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//订单用户领取明细
export  function getAjClothesOrderItemDetails(data) {
	return request2({
		url: "/aj-clothes-order/getAjClothesOrderItemDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取订单规格申请项
export  function getCustomAjClothesWareScaleList(data) {
	return request2({
		url: "/aj-clothes-apply-custom/getCustomAjClothesWareScaleList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑订单规格申请项
export  function updateCustomAjClothesApplyItem(data) {
	return request2({
		url: "/aj-clothes-apply-custom/updateCustomAjClothesApplyItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出订单申请
export  function exportAjClothesApply(data) {
	return request2({
		url: "/aj-clothes-apply/exportAjClothesApply",
		method: "POST",
		data:qs.stringify(data)
	})
}
//http请求列表
export  function getSysMsgErrorHttpList(data) {
	return request({
		url: "/sys-msg-error-http/getSysMsgErrorHttpList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//http请求-处理
export  function updateSysMsgErrorHttpStatus(data) {
	return request({
		url: "/sys-msg-error-http/updateSysMsgErrorHttpStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//http请求-重新发起
export  function updateSysMsgErrorHttpStatusRepeat(data) {
	return request({
		url: "/sys-msg-error-http/updateSysMsgErrorHttpStatusRepeat",
		method: "POST",
		data:qs.stringify(data)
	})
}
//申请记录 -归还
export  function updateAjUserBorrowApplyReturn(data) {
	return request({
		url: "/aj-user-borrow-apply/updateAjUserBorrowApplyReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增号卡话费账单
export  function addAjUserPhoneUse(data) {
	return request({
		url: "/aj-user-phone-use/addAjUserPhoneUse",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除号卡话费记录
export  function deleteAjUserPhoneUse(data) {
	return request({
		url: "/aj-user-phone-use/deleteAjUserPhoneUse",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出号卡话费记录
export  function exportAjUserPhoneUse(data) {
	return request({
		url: "/aj-user-phone-use/exportAjUserPhoneUse",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取号卡话费记录
export  function getAjUserPhoneUseList(data) {
	return request({
		url: "/aj-user-phone-use/getAjUserPhoneUseList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑号卡话费记录
export  function updateAjUserPhoneUse(data) {
	return request({
		url: "/aj-user-phone-use/updateAjUserPhoneUse",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量导入号卡话费记录
export  function uploadAjUserPhoneUse(data) {
	return request({
		url: "/aj-user-phone-use/uploadAjUserPhoneUse",
		method: "POST",
		data
	})
}
//批量导入号卡话费记录-执行
export  function uploadImportAjUserPhoneUse(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjUserPhoneUse",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增合同记录
export  function addAjSupplierContract(data) {
	return request({
		url: "/aj-supplier-contract/addAjSupplierContract",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除合同记录
export  function deleteAjSupplierContract(data) {
	return request({
		url: "/aj-supplier-contract/deleteAjSupplierContract",
		method: "POST",
		data:qs.stringify(data)
	})
}
//合同记录
export  function getAjSupplierContractList(data) {
	return request({
		url: "/aj-supplier-contract/getAjSupplierContractList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑合同记录
export  function updateAjSupplierContract(data) {
	return request({
		url: "/aj-supplier-contract/updateAjSupplierContract",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增供应商
export  function addAjSupplierBase(data) {
	return request({
		url: "/aj-supplier-base/addAjSupplierBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除供应商
export  function deleteAjSupplierBase(data) {
	return request({
		url: "/aj-supplier-base/deleteAjSupplierBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表供应商
export  function getAjSupplierBaseList(data) {
	return request({
		url: "/aj-supplier-base/getAjSupplierBaseList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑供应商
export  function updateAjSupplierBase(data) {
	return request({
		url: "/aj-supplier-base/updateAjSupplierBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增物业
export  function addAjSupplierProperty(data) {
	return request({
		url: "/aj-supplier-property/addAjSupplierProperty",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除物业
export  function deleteAjSupplierProperty(data) {
	return request({
		url: "/aj-supplier-property/deleteAjSupplierProperty",
		method: "POST",
		data:qs.stringify(data)
	})
}
//物业
export  function getAjSupplierPropertyList(data) {
	return request({
		url: "/aj-supplier-property/getAjSupplierPropertyList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑物业
export  function updateAjSupplierProperty(data) {
	return request({
		url: "/aj-supplier-property/updateAjSupplierProperty",
		method: "POST",
		data:qs.stringify(data)
	})
}
//人员变动
export  function getAjUserStatisticsYear(data) {
	return request({
		url: "/aj-user-statistics/getAjUserStatisticsYear",
		method: "POST",
		data:qs.stringify(data)
	})
}
//恒英批量导入
export  function uploadAjSocialBaseMulti(data) {
	return request({
		url: "/aj-social-base-multi/uploadAjSocialBaseMulti",
		method: "POST",
		data
	})
}
//恒英批量导入-执行
export  function uploadImportAjSocialBaseMulti(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjSocialBaseMulti",
		method: "POST",
		data:qs.stringify(data)
	})
}
//答题结果列表
export  function getIvqPaperRecordAssetsList(data) {
	return request2({
		url: "/ivq-paper-record-assets/getIvqPaperRecordAssetsList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//答题结果详情
export  function getIvqPaperRecordDetails(data) {
	return request2({
		url: "/ivq-paper-record-assets/getIvqPaperRecordDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//故障记录-导出
export  function exportAjAssetsHitch(data) {
	return request({
		url: "/aj-assets-hitch/exportAjAssetsHitch",
		method: "POST",
		data:qs.stringify(data)
	})
}
//合同管理-合同附件列表
export  function getAjSupplierContractFilesList(data) {
	return request({
		url: "/aj-supplier-contract-files/getAjSupplierContractFilesList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//合同管理-合同附件新增
export  function addAjSupplierContractFiles(data) {
	return request({
		url: "/aj-supplier-contract-files/addAjSupplierContractFiles",
		method: "POST",
		data:qs.stringify(data)
	})
}
//合同管理-合同附件编辑
export  function updateAjSupplierContractFiles(data) {
	return request({
		url: "/aj-supplier-contract-files/updateAjSupplierContractFiles",
		method: "POST",
		data:qs.stringify(data)
	})
}
//合同管理-合同附件删除
export  function deleteAjSupplierContractFiles(data) {
	return request({
		url: "/aj-supplier-contract-files/deleteAjSupplierContractFiles",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取钉钉发送的消息
export  function getSysMsgDingRobotsList(data) {
	return request({
		url: "/sys-msg-ding-robots/getSysMsgDingRobotsList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取资产登记表详情
export  function getAjUserExpandDetails(data) {
	return request({
		url: "/aj-user-expand/getAjUserExpandDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}

//项目任务-新增项目任务
export  function addSysCjProjectTask(data) {
	return request({
		url: "/sys-cj-project-task/addSysCjProjectTask",
		method: "POST",
		data:qs.stringify(data)
	})
}
//项目任务-删除项目任务
export  function deleteSysCjProjectTask(data) {
	return request({
		url: "/sys-cj-project-task/deleteSysCjProjectTask",
		method: "POST",
		data:qs.stringify(data)
	})
}
//项目任务-编辑项目任务
export  function updateSysCjProjectTask(data) {
	return request({
		url: "/sys-cj-project-task/updateSysCjProjectTask",
		method: "POST",
		data:qs.stringify(data)
	})
}
//项目任务-获取项目任务
export  function getSysCjProjectTaskList(data) {
	return request({
		url: "/sys-cj-project-task/getSysCjProjectTaskList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//项目任务-修改状态
export  function updateSysCjProjectTaskStatus(data) {
	return request({
		url: "/sys-cj-project-task/updateSysCjProjectTaskStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//项目任务-后端状态
export  function updateSysCjProjectTaskStatusBack(data) {
	return request({
		url: "/sys-cj-project-task/updateSysCjProjectTaskStatusBack",
		method: "POST",
		data:qs.stringify(data)
	})
}
//项目任务-前端状态
export  function updateSysCjProjectTaskStatusWeb(data) {
	return request({
		url: "/sys-cj-project-task/updateSysCjProjectTaskStatusWeb",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-新增手册分类
export  function addAjInductionManualClass(data) {
	return request({
		url: "/aj-induction-manual-class/addAjInductionManualClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-获取手册分类
export  function getAjInductionManualClassList(data) {
	return request({
		url: "/aj-induction-manual-class/getAjInductionManualClassList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-编辑手册分类
export  function updateAjInductionManualClass(data) {
	return request({
		url: "/aj-induction-manual-class/updateAjInductionManualClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-删除手册分类
export  function deleteAjInductionManualClass(data) {
	return request({
		url: "/aj-induction-manual-class/deleteAjInductionManualClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-新增手册
export  function addAjInductionManualBase(data) {
	return request({
		url: "/aj-induction-manual-base/addAjInductionManualBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-删除手册
export  function deleteAjInductionManualBase(data) {
	return request({
		url: "/aj-induction-manual-base/deleteAjInductionManualBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-获取手册
export  function getAjInductionManualBaseList(data) {
	return request({
		url: "/aj-induction-manual-base/getAjInductionManualBaseList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-编辑手册
export  function updateAjInductionManualBase(data) {
	return request({
		url: "/aj-induction-manual-base/updateAjInductionManualBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-领用记录手册
export  function getAjInductionManualBorrowRecordList(data) {
	return request({
		url: "/aj-induction-manual-borrow-record/getAjInductionManualBorrowRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-领用记录手册详情
export  function getAjInductionManualBorrowRecordDetails(data) {
	return request({
		url: "/aj-induction-manual-borrow-record/getAjInductionManualBorrowRecordDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-领用记录手册确认归还
export  function updateAjInductionManualBorrowRecordReturn(data) {
	return request({
		url: "/aj-induction-manual-borrow-record/updateAjInductionManualBorrowRecordReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-删除领用记录
export  function deleteAjInductionManualBorrowRecord(data) {
	return request({
		url: "/aj-induction-manual-borrow-record/deleteAjInductionManualBorrowRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//入职培训-删除入职培训签到表
export  function deleteAjInductionTrainingSign(data) {
	return request({
		url: "/aj-induction-training-sign/deleteAjInductionTrainingSign",
		method: "POST",
		data:qs.stringify(data)
	})
}
//入职培训-获取入职培训签到表
export  function getAjInductionTrainingSignList(data) {
	return request({
		url: "/aj-induction-training-sign/getAjInductionTrainingSignList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出-手册
export  function exportAjInductionManualBase(data) {
	return request({
		url: "/aj-induction-manual-base/exportAjInductionManualBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出-新员工签到word
export  function exportAjInductionTrainingSignWord(data) {
	return request({
		url: "/aj-induction-training-sign/exportAjInductionTrainingSignWord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册领用记录员工列表
export  function getAjInductionManualBorrowRecordListAuNames(data) {
	return request({
		url: "/aj-induction-manual-borrow-record/getAjInductionManualBorrowRecordListAuNames",
		method: "POST",
		data:qs.stringify(data)
	})
}

//导出-手册领用word
export  function exportAjInductionManualBorrowRecordWordReturn(data) {
	return request({
		url: "/aj-induction-manual-borrow-record/exportAjInductionManualBorrowRecordWordReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出-手册领用word
export  function exportAjInductionManualBorrowRecordWord(data) {
	return request({
		url: "/aj-induction-manual-borrow-record/exportAjInductionManualBorrowRecordWord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增公司钥匙
export  function addAjAssetsKey(data) {
	return request({
		url: "/aj-assets-key/addAjAssetsKey",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除公司钥匙
export  function deleteAjAssetsKey(data) {
	return request({
		url: "/aj-assets-key/deleteAjAssetsKey",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取公司钥匙
export  function getAjAssetsKeyList(data) {
	return request({
		url: "/aj-assets-key/getAjAssetsKeyList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑公司钥匙
export  function updateAjAssetsKey(data) {
	return request({
		url: "/aj-assets-key/updateAjAssetsKey",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑公司钥匙状态
export  function updateAjAssetsKeyStatus(data) {
	return request({
		url: "/aj-assets-key/updateAjAssetsKeyStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量导入公司钥匙
export  function uploadAjAssetsKey(data) {
	return request({
		url: "/aj-assets-key/uploadAjAssetsKey",
		method: "POST",
		data
	})
}
//编辑公司钥匙状态
export  function uploadImportAjAssetsKey(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjAssetsKey",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增钥匙领用记录
export  function addAjAssetsKeyBorrowReturn(data) {
	return request({
		url: "/aj-assets-key-borrow-return/addAjAssetsKeyBorrowReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除钥匙领用记录
export  function deleteAjAssetsKeyBorrowReturn(data) {
	return request({
		url: "/aj-assets-key-borrow-return/deleteAjAssetsKeyBorrowReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//列表钥匙领用记录
export  function getAjAssetsKeyBorrowReturnList(data) {
	return request({
		url: "/aj-assets-key-borrow-return/getAjAssetsKeyBorrowReturnList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑钥匙领用记录-日期
export  function updateAjAssetsKeyBorrowReturnDate(data) {
	return request({
		url: "/aj-assets-key-borrow-return/updateAjAssetsKeyBorrowReturnDate",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-补卡申请获取列表
export  function getAjAttendanceRecordRepairList(data) {
	return request({
		url: "/aj-attendance-record-repair/getAjAttendanceRecordRepairList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-补卡申请获取列表-从钉钉同步数据
export  function getAjAttendanceRecordRepairSyncDingTalk(data) {
	return request({
		url: "/aj-attendance-record-repair/getAjAttendanceRecordRepairSyncDingTalk",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-出差申请获取列表
export  function getAjAttendanceAwayOfficialList(data) {
	return request({
		url: "/aj-attendance-away-official/getAjAttendanceAwayOfficialList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-出差申请获取列表-从钉钉同步数据
export  function getAjAttendanceAwayOfficialSyncDingTalk(data) {
	return request({
		url: "/aj-attendance-away-official/getAjAttendanceAwayOfficialSyncDingTalk",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-加班申请获取列表
export  function getAjAttendanceOvertimeList(data) {
	return request({
		url: "/aj-attendance-overtime/getAjAttendanceOvertimeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-加班申请获取列表-从钉钉同步数据
export  function getAjAttendanceOvertimeSyncDingTalk(data) {
	return request({
		url: "/aj-attendance-overtime/getAjAttendanceOvertimeSyncDingTalk",
		method: "POST",
		data:qs.stringify(data)
	})
}

//考勤记录-居家申请获取列表
export  function getAjAttendanceRecordHomeList(data) {
	return request({
		url: "/aj-attendance-record-home/getAjAttendanceRecordHomeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-居家申请获取列表-从钉钉同步数据
export  function getAjAttendanceRecordHomeSyncDingTalk(data) {
	return request({
		url: "/aj-attendance-record-home/getAjAttendanceRecordHomeSyncDingTalk",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-考勤记录获取列表
export  function getAjAttendanceRecordList(data) {
	return request({
		url: "/aj-attendance-record/getAjAttendanceRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-考勤记录获取列表-从钉钉同步数据
export  function getAjAttendanceRecordSyncDingTalk(data) {
	return request({
		url: "/aj-attendance-record/getAjAttendanceRecordSyncDingTalk",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-请假申请获取列表
export  function getAjAttendanceLeaveList(data) {
	return request({
		url: "/aj-attendance-leave/getAjAttendanceLeaveList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-请假申请获取列表-从钉钉同步数据
export  function getAjAttendanceLeaveSyncDingTalk(data) {
	return request({
		url: "/aj-attendance-leave/getAjAttendanceLeaveSyncDingTalk",
		method: "POST",
		data:qs.stringify(data)
	})
}

//考勤记录-外出申请获取列表
export  function getAjAttendanceRecordOutList(data) {
	return request({
		url: "/aj-attendance-record-out/getAjAttendanceRecordOutList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-外出申请获取列表-从钉钉同步数据
export  function getAjAttendanceRecordOutSyncDingTalk(data) {
	return request({
		url: "/aj-attendance-record-out/getAjAttendanceRecordOutSyncDingTalk",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-汇总
export  function getAjAttendanceTableUserList(data) {
	return request({
		url: "/aj-attendance-table-user/getAjAttendanceTableUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//考勤记录-汇总
export  function updateAjAttendanceTableUserSync(data) {
	return request({
		url: "/aj-attendance-table-user/updateAjAttendanceTableUserSync",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消防设备-新增
export  function addAjAssetsFireEquipment(data) {
	return request({
		url: "/aj-assets-fire-equipment/addAjAssetsFireEquipment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消防设备-编辑
export  function updateAjAssetsFireEquipment(data) {
	return request({
		url: "/aj-assets-fire-equipment/updateAjAssetsFireEquipment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消防设备-列表
export  function getAjAssetsFireEquipmentList(data) {
	return request({
		url: "/aj-assets-fire-equipment/getAjAssetsFireEquipmentList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消防设备-删除
export  function deleteAjAssetsFireEquipment(data) {
	return request({
		url: "/aj-assets-fire-equipment/deleteAjAssetsFireEquipment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消防设备-批量导入
export  function uploadAjAssetsFireEquipment(data) {
	return request({
		url: "/aj-assets-fire-equipment/uploadAjAssetsFireEquipment",
		method: "POST",
		data
	})
}
//公司宿舍-新增
export  function addAjHostelBase(data) {
	return request({
		url: "/aj-hostel-base/addAjHostelBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公司宿舍-删除
export  function deleteAjHostelBase(data) {
	return request({
		url: "/aj-hostel-base/deleteAjHostelBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公司宿舍-列表
export  function getAjHostelBaseList(data) {
	return request({
		url: "/aj-hostel-base/getAjHostelBaseList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公司宿舍-编辑
export  function updateAjHostelBase(data) {
	return request({
		url: "/aj-hostel-base/updateAjHostelBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消防设备-批量导入执行
export  function uploadImportAjAssetsFireEquipment(data) {
	return request({
		url: "/sys-import-tem/uploadImportAjAssetsFireEquipment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公司宿舍-入住申请列表
export  function getAjHostelApplyList(data) {
	return request({
		url: "/aj-hostel-apply/getAjHostelApplyList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公司宿舍-入住申请审核
export  function updateAjHostelApplyCheck(data) {
	return request({
		url: "/aj-hostel-apply/updateAjHostelApplyCheck",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公司宿舍-编辑预计退房时间
export  function updateAjHostelApplyDateCheckOut(data) {
	return request({
		url: "/aj-hostel-apply/updateAjHostelApplyDateCheckOut",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公司宿舍-退房申请
export  function getAjHostelCheckOutList(data) {
	return request({
		url: "/aj-hostel-check-out/getAjHostelCheckOutList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公司宿舍-退房申请审核
export  function updateAjHostelCheckOutCheck(data) {
	return request({
		url: "/aj-hostel-check-out/updateAjHostelCheckOutCheck",
		method: "POST",
		data:qs.stringify(data)
	})
}
//公司宿舍-入住历史
export  function getAjHostelBaseDetails(data) {
	return request({
		url: "/aj-hostel-base/getAjHostelBaseDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量上传公司手册
export  function uploadAjInductionManualBase(data) {
	return request({
		url: "/aj-induction-manual-base/uploadAjInductionManualBase",
		method: "POST",
		data
	})
}
export  function exportAjUserFiles(data) {
	return request({
		url: "/aj-user-sub/exportAjUserFiles",
		method: "POST",
		data:qs.stringify(data)
	})
}

//花名册-资质证书根据模板批量导出
export  function uploadAjUserProveReturnFilesAssets(data) {
	return request({
		url: "/aj-user-prove/uploadAjUserProveReturnFilesAssets",
		method: "POST",
		data
	})
}
//公司宿舍-退房申请
export  function addAjHostelCheckOutSystem(data) {
	return request({
		url: "/aj-hostel-check-out/addAjHostelCheckOutSystem",
		method: "POST",
		data:qs.stringify(data)
	})
}
//机器人消息-新增
export  function addFxxkDingUserMsg(data) {
	return request2({
		url: "/fxxk-ding-user-msg/addFxxkDingUserMsg",
		method: "POST",
		data:qs.stringify(data)
	})
}
//机器人消息-编辑
export  function updateFxxkDingUserMsg(data) {
	return request2({
		url: "/fxxk-ding-user-msg/updateFxxkDingUserMsg",
		method: "POST",
		data:qs.stringify(data)
	})
}
//机器人消息-列表
export  function getFxxkDingUserMsgList(data) {
	return request2({
		url: "/fxxk-ding-user-msg/getFxxkDingUserMsgList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//机器人消息-消息详情列表
export  function getFxxkDingUserMsgSendList(data) {
	return request2({
		url: "/fxxk-ding-user-msg/getFxxkDingUserMsgSendList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//机器人消息-消息详情记录编辑取消发送
export  function updateFxxkDingUserMsgCancel(data) {
	return request2({
		url: "/fxxk-ding-user-msg/updateFxxkDingUserMsgCancel",
		method: "POST",
		data:qs.stringify(data)
	})
}
//机器人消息-消息详情记录编辑单独发送
export  function updateFxxkDingUserMsgSend(data) {
	return request2({
		url: "/fxxk-ding-user-msg/updateFxxkDingUserMsgSend",
		method: "POST",
		data:qs.stringify(data)
	})
}
//机器人消息-消息详情记录编辑重新发送
export  function updateFxxkDingUserMsgSendRepeat(data) {
	return request2({
		url: "/fxxk-ding-user-msg/updateFxxkDingUserMsgSendRepeat",
		method: "POST",
		data:qs.stringify(data)
	})
}
//机器人消息-批量上传文件
export  function uploadFxxkDingUserReturnIdsList(data) {
	return request2({
		url: "/fxxk-ding-user-msg/uploadFxxkDingUserReturnIdsList",
		method: "POST",
		data
	})
}
//钉钉用户列表
export  function getFxxkDingUserList(data) {
	return request2({
		url: "/fxxk-ding-user/getFxxkDingUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}


	